import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import karnts from '../assets/karnts.png';
import logo2 from '../assets/logo2.png';


class SeminarKarnt extends Component {

  render() {

    return (
      <div className='BioSantis'>
        <h1>Member's Details</h1>
        <img className='santis' src={karnts}></img>
        <h2>MR.KARNT SRISUWAN</h2>
        <br />
        <div>
        COUNTRY : THAILAND
        </div>
        <br />

        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default SeminarKarnt;
